module.exports = __webpack_public_path__ + "img/logo-instagram.929ce16e.svg";